import React, { useState, useEffect } from "react"
import { Button, Col, Row, Table, Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import { sampleItems } from "../../../../Helpers/mockData/mockData"
import Navbar from "../../../../Components/Navbar/Navbar"
import "../../PurchaseOrders/PurchaseOrders.css"
import Modal from "antd/es/modal/Modal"
import {
  dateFormat,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import {
  approveSuppliesExpense,
  getSingleSuppliesExpense,
} from "../../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import { getType } from "../../../../Helpers/Utils/Common"
import SEModal from "./SEModal"
import PaymentTable from "../../../Sales/PaymentTable"
import Moment from "moment"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"
import AttachmentModal from "../../../../Components/AttachmentModal/AttachmentModal"

export default function ReviewSuppliesExpense() {
  const { id } = useParams()
  let navigate = useNavigate()

  /* Disapprove Modal */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const handleShowDisapproveModal = () => setShowDisapproveModal(true)
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false)

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = () => setShowApproveModal(true)
  const handleCloseApproveModal = () => setShowApproveModal(false)

  /* Pending Modal */
  const [showPendingModal, setShowPendingModal] = useState(false)
  const handleShowPendingModal = () => setShowPendingModal(true)
  const handleClosePendingModal = () => setShowPendingModal(false)

  /* Attachments Modal */
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
  const handleShowAttachmentsModal = () => setShowAttachmentsModal(true)
  const handleCloseAttachmentsModal = () => setShowAttachmentsModal(false)

  const [inactive, setInactive] = useState(true)
  const [reviewSE, setReviewSE] = useState([])
  const [items, setItems] = useState([])
  const [status, setStatus] = useState("")
  const [paymentInfo, setPaymentInfo] = useState([])

  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [startAt, setStartAt] = useState(0)

  /** GET API - Get single supplies expense **/
  async function fetchSingleSuppliesExpense() {
    const response = await getSingleSuppliesExpense(id)
    if (response.data) {
      var data = response.data.data[0]
      setFileList(data.supplies_expense_attachments)
      if (Array.isArray(data.invoice_no)) {
        data.invoice_no = data.invoice_no?.map((invoice) => {
          return invoice.invoice_no ? invoice.invoice_no : "N/A"
        })
      } else {
        data.invoice_no = data.invoice_no
      }
      var items = data.supplies_expense_items.map((item) => {
        var info = item
        info.qty = parseInt(item.qty)
        info.received_qty = item.received_qty ? parseInt(item.received_qty) : 0
        info.remaining_qty = item.remaining_qty
          ? parseInt(item.remaining_qty)
          : 0
        info.current_qty = item.current_qty ? parseInt(item.current_qty) : 0
        info.unit = item.unit
        info.price = `PHP ${numberFormat(item.price)}`
        info.amount = `PHP ${numberFormat(item.total)}`
        info.remarks = item.remarks || "-"
        info.last_received_date = item.last_received_date
          ? dateFormat(item.last_received_date)
          : "--/--/---"
        info.last_received_by = item.last_received_by
          ? item.last_received_by
          : "N/A"
        return info
      })
      setReviewSE(data)
      setItems(items)

      var payment = data.supplies_expense_payments?.map((data) => {
        var info = data
        info.payment_date = Moment(data.payment_date).format("MM-DD-YYYY")
        info.type = data.payment_mode
        info.details =
          data.payment_mode === "check"
            ? data.payment_mode + " - " + data.check_no
            : data.payment_mode === "bank"
            ? data.payment_mode + " - " + data.reference_no
            : data.payment_mode
        info.amount = data.amount ? numberFormat(data.amount) : "0.00"
        info.amount_applied_to_invoice = data.amount_applied_to_invoice
          ? numberFormat(data.amount_applied_to_invoice)
          : "0.00"
        return info
      })
      setPaymentInfo(payment)
    } else if (response.error) {
      TokenExpiry(response)
    }
  }

  function approveSE(state) {
    if (state === "disapproved") {
      handleShowDisapproveModal()
    } else if (state === "sent") {
      handleShowApproveModal()
    } else {
      handleShowPendingModal()
    }

    setStatus(state)
  }

  useEffect(() => {
    fetchSingleSuppliesExpense()
  }, [])

  const headersIncompleteOrComplete = [
    "Item",
    "Ordered Qty",
    "Received Qty",
    "Balance",
    "Current Qty",
    "Unit",
    "Unit Price",
    "Amount",
    "Remarks",
    "Latest Invoice Date",
    "Received by",
  ]
  const selectorsIncompleteOrComplete = [
    "name",
    "qty",
    "received_qty",
    "remaining_qty",
    "current_qty",
    "unit",
    "price",
    "amount",
    "remarks",
    "last_received_date",
    "last_received_by",
  ]

  const headers = [
    "Item",
    "Ordered Qty",
    "Current Qty",
    "Unit",
    "Unit Price",
    "Amount",
    "Remarks",
  ]
  const selectors = [
    "name",
    "qty",
    "current_qty",
    "unit",
    "price",
    "amount",
    "remarks",
  ]

  function handleClickImageThumbnail(index) {
    handleShowAttachmentsModal()
    setStartAt(index)
  }

  console.log(fileList)

  function renderTable() {
    return (
      <>
        <Table>
          <thead>
            <tr>
              {reviewSE.order_status === "incomplete" ||
              reviewSE.order_status === "complete" ? (
                <>
                  {headersIncompleteOrComplete.map((header) => {
                    return <th>{header}</th>
                  })}
                </>
              ) : (
                <>
                  {headers.map((header) => {
                    return <th>{header}</th>
                  })}
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              return reviewSE.order_status === "incomplete" ||
                reviewSE.order_status === "complete" ? (
                <tr key={item.id}>
                  {selectorsIncompleteOrComplete.map((selector) => {
                    return <td>{item[selector]}</td>
                  })}
                </tr>
              ) : (
                <tr key={item.id}>
                  {selectors.map((selector) => {
                    return <td>{item[selector]}</td>
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </>
    )
  }

  async function submitApproveSE() {
    const response = await approveSuppliesExpense(id, status)
    var text
    if (status === "pending") {
      text = "Returned to Pending"
    } else {
      text = status
    }

    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      if (status === "sent") {
        setTimeout(
          () =>
            navigate("/suppliesexpenses/print/" + id, {
              state: {
                type: text.toLowerCase(),
                suppID: reviewSE.supplier_id,
              },
            }),
          1000
        )
      } else {
        setTimeout(() => navigate("/suppliesexpenses"), 1000)
      }
    } else if (response.error) {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  function renderButtons() {
    switch (reviewSE.order_status) {
      case "incomplete":
        return (
          <button
            type="button"
            className="button-secondary"
            onClick={() => navigate("/suppliesexpenses")}
          >
            Close
          </button>
        )
      case "complete":
        return (
          <button
            type="button"
            className="button-secondary"
            onClick={() => navigate("/suppliesexpenses")}
          >
            Close
          </button>
        )
      default:
        return (
          <>
            <button
              type="button"
              className="button-secondary me-1"
              onClick={() => navigate("/suppliesexpenses")}
            >
              Close
            </button>
            {getType() === "admin" ? (
              <button
                type="button"
                className="button-warning me-1 py-2"
                onClick={() => approveSE("disapproved")}
              >
                Disapprove
              </button>
            ) : null}
            <button
              type="button"
              className="button-tertiary me-1"
              onClick={() =>
                navigate("/suppliesexpenses/edit/for_approval/" + id)
              }
            >
              Edit
            </button>
            <button
              type="button"
              className="button-primary"
              onClick={() => approveSE("sent")}
            >
              Approve
            </button>
          </>
        )
    }
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>
      <div
        className={`manager-container ${
          inactive ? "inactive" : "active"
        } review-container-main`}
      >
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              REVIEW SUPPLIES EXPENSE{" "}
            </h1>
          </Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">SUPPLIES EXPENSE NO. {id}</span>
          </Col>
        </Row>

        {/* content */}
        <div className="review-form mb-3">
          <Row className="review-container py-3">
            <Col xs={6} lg={3}>
              <Row>
                <span className="review-label mb-2">Supplier Name</span>
              </Row>
              <Row>
                <span className="review-data">
                  {reviewSE.supplier_trade_name ||
                    reviewSE.vendor_trade_name ||
                    "N/A"}
                </span>
              </Row>
            </Col>
            <Col xs={6} lg={3}>
              <Row>
                <span className="review-label mb-2">Type</span>
              </Row>
              <Row>
                <span className="review-data">{reviewSE.type || "N/A"}</span>
              </Row>
            </Col>
            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
              <Row>
                <span className="review-label mb-2">Purchase Date</span>
              </Row>
              <Row>
                <span className="review-data">
                  {dateFormat(reviewSE.supplies_expense_date)}
                </span>
              </Row>
            </Col>
            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
              <Row>
                <span className="review-label mb-2">Invoice No.</span>
              </Row>
              <Row>
                <span className="review-data">{reviewSE.invoice_no}</span>
              </Row>
            </Col>
          </Row>
          <Row className="review-container py-3">
            <Col>
              <Row>
                <Col xs={6} lg={3}>
                  <Row>
                    <span className="review-label mb-2">Branch</span>
                  </Row>
                  <Row>
                    <span className="review-data">{reviewSE.branch_name}</span>
                  </Row>
                </Col>
                <Col xs={6} lg={3}>
                  <Row>
                    <span className="review-label mb-2">Delivery Address</span>
                  </Row>
                  <Row>
                    <span className="review-data">
                      {reviewSE.delivery_address}
                    </span>
                  </Row>
                </Col>
                <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                  <Row>
                    <span className="review-label mb-2">Forwarder</span>
                  </Row>
                  <Row>
                    <span className="review-data">
                      {reviewSE.forwarder_name}
                    </span>
                  </Row>
                </Col>
                <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                  <Row>
                    <span className="review-label mb-2">
                      Forwarder Contact No
                    </span>
                  </Row>
                  <Row>
                    <span className="review-data">
                      {reviewSE.forwarder_contact_person}
                    </span>
                  </Row>
                </Col>
                <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                  <Row>
                    <span className="review-label mb-2">Declared Value</span>
                  </Row>
                  <Row>
                    <span className="review-data">
                      {numberFormat(reviewSE.declared_value)}
                    </span>
                  </Row>
                </Col>
                <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                  <Row>
                    <span className="review-label mb-2">Requisitioner</span>
                  </Row>
                  <Row>
                    <span className="review-data">
                      {reviewSE.requisitioner_name}
                    </span>
                  </Row>
                </Col>
                <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                  <Row>
                    <span className="review-label mb-2">Remarks</span>
                  </Row>
                  <Row>
                    <span className="review-data">{reviewSE.remarks}</span>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="mt-4 d-flex flex-column">
            <span className="review-data mb-2">PURCHASED ITEMS</span>
            <div className="review-purchased-items purchased-items">
              {renderTable()}
            </div>
            <div className="d-flex justify-content-end mt-4 mx-5">
              <div className="print-table-footer-label grand-label">
                GRAND TOTAL
                <span className="mx-2 print-table-footer-data grand-label">
                  PHP {numberFormat(reviewSE.grand_total)}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-4 noPrint ms-0">
            <Row className="review-data ms-1 mb-2">FILE ATTACHMENTS</Row>
            <div className="d-flex flex-row gap-2 overflow-auto">
              {fileList &&
                fileList.map((attachment, index) => (
                  <div
                    // onClick={() => {
                    //   setPreviewFile(attachment.file_url)
                    //   setPreview(true)
                    // }}
                    key={index}
                    className="thumbnail-cont"
                  >
                    <img
                      src={attachment.file_url}
                      className="image-thumbnail"
                      alt=""
                      onClick={() => handleClickImageThumbnail(index)}
                    />
                  </div>
                ))}
              {!fileList ||
                (fileList.length === 0 && (
                  <div>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end pb-5">{renderButtons()}</div>
        {reviewSE.status === "sent" &&
          (reviewSE.order_status === "complete" ||
            reviewSE.order_status === "incomplete") && (
            <>
              <Container
                fluid
                className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
              >
                <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
                <div className="justify-content-center">
                  <PaymentTable
                    tableHeaders={[
                      "PAYMENT DATE",
                      "TYPE",
                      "DETAILS",
                      "PAYMENT AMOUNT",
                      "AMOUNT APPLIED TO INV",
                    ]}
                    headerSelector={[
                      "payment_date",
                      "type",
                      "details",
                      "amount",
                      "amount_applied_to_invoice",
                    ]}
                    tableData={paymentInfo}
                  />
                </div>
              </Container>
            </>
          )}
        {/* Modals */}
        <SEModal
          show={showApproveModal}
          hide={handleCloseApproveModal}
          type="approve"
          handler={submitApproveSE}
        />
        <SEModal
          show={showDisapproveModal}
          hide={handleCloseDisapproveModal}
          type="disapprove"
          handler={submitApproveSE}
        />
        <SEModal
          show={showPendingModal}
          hide={handleClosePendingModal}
          type="return"
          handler={submitApproveSE}
        />
        <AttachmentModal
          show={showAttachmentsModal}
          images={fileList}
          onHide={() => handleCloseAttachmentsModal()}
          selected={startAt}
        />
        <Modal
          open={preview}
          title={""}
          footer={null}
          onCancel={() => setPreview(false)}
        >
          <img
            alt="attachment"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
        </Modal>
      </div>
      <Footer />
    </div>
  )
}
